import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const NumberSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default NumberSVG;
